// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"_1sK3czExL65KdHDGCbW3Gd"};